module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAAAXNSR0IArs4c6QAAAQpJREFUKFOlkj8vBAEQxX9vJVfoRC3xASQ64i5irxOfQeU2ITQSBREiQqFUiITsVjo+xN02/nVKnehUCiqX2ycXOdllzxWmnJlfZt7MU5h4A7wOjPA72pI2m0s675UUJtkz5onA14X+TFXELPBmay2NdNGtd4F3rKNWpMM8ECadE9AC8AjUbDXSSFd/A9Z8paLqR9uXwATSyqAJi8AtZtiiJnjpC9QTbxt3V+rFKDDWF/h5sDD2DvJWAZiLO/uSpvPNtu/SaGivFAhjLxNkM8XzBjetSGelQMnjvlOlQD32qoNsKg8qC+6bkU7LNSTeFZ4saEAPaUMH/1qp3Es/BX15a1wD3JrHXkHHnyuTt4Zj+d5rAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/nrgl_active.png
// module id = j2gF
// module chunks = 3